import { bianka, logger } from '@fiverr-private/obs';
import { ModelCardComponent } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/model_card_component';
import { AdditionalData, Click, Hover } from '@fiverr-private/bianka_js';
import { ReportBiEventParams } from './reportBiEvent.types';

export const reportBiEvent = ({
    biEventData,
    activityType,
    eventType,
    elementName,
    elementType,
    clickType,
    impressionId = 'unknown',
}: ReportBiEventParams) => {
    if (biEventData) {
        const {
            gigId,
            userId,
            sellerId,
            ctxId,
            pageName,
            componentName,
            aiModelId,
            modelPrice = -1,
            modelName = 'unknown',
            modelCluster = 'unknown',
        } = biEventData;
        bianka.reportActivity<Click | Hover, ModelCardComponent>({
            type: activityType,
            event: {
                type: eventType,
                ...(gigId && { gig: { id: gigId } }),
                ...(userId && { user: { id: userId } }),
                ...(sellerId && { seller: { id: sellerId } }),
                page: {
                    name: pageName,
                    ctxId,
                    ...(componentName && {
                        referrer: {
                            name: componentName,
                            ctxId,
                        },
                    }),
                },
                element: {
                    name: elementName,
                    type: elementType,
                },
                ...(clickType && { clickType }),
            },
            ...(aiModelId && {
                additionalData: {
                    type: ModelCardComponent,
                    message: {
                        modelCardAttributes: {
                            id: aiModelId,
                            price: modelPrice,
                            modelName,
                            cluster: modelCluster,
                            imp: impressionId,
                        },
                    },
                    // Missing "imp" field failes the entire TS definition,
                    // so we're temporary suppressing the error with type assertion
                } as AdditionalData<ModelCardComponent>,
            }),
        });
    } else {
        bianka.reportActivity({
            type: activityType,
            event: {
                type: eventType,
                element: {
                    name: elementName,
                    type: elementType,
                },
                ...(clickType && { clickType }),
            },
        });

        logger.info({
            description: 'Failed to report BI event missing biEventData',
            eventType,
            elementName,
        });
    }
};
